export default {
  namespaced: true,

  state: () => ({
    text: "",
    color: "",
    flag: false
  }),

  getters: {
    getSnakbar(state) {
      return state;
    }
  },

  actions: {
    setSnackbar({ commit }, items) {
      commit("SET_SNACKBAR", items);
    }
  },

  mutations: {
    SET_SNACKBAR(state, { flag, text, color }) {
      state.flag = flag;
      state.text = text;
      state.color = color;
      console.log({ state });
    }
  }
};
